import {lazyInitialize, nonenumerable} from 'core-decorators';

import APIRequestState from 'spa/state/_util/api-request';

class SpecialitiesFAQRequest extends APIRequestState {
  getRequest(params) {
    return this.ctx.sdk.get(`/specialities/${params.id}/faqs`);
  }
}

class SpecialitiesFAQState {
  /*
   * Lazy load our required state
   */
  @lazyInitialize @nonenumerable speciality = new SpecialitiesFAQRequest(this.ctx);

  constructor(ctx) {
    Object.defineProperty(this, 'ctx', {
      value: ctx,
      enumerable: false,
    });
  }
}

export default SpecialitiesFAQState;



// WEBPACK FOOTER //
// ./spa/state/specialities-faq.jsx